import { merge } from "lodash";
import { pluck, reject } from "underscore";

export function mergePlans(left, right) {
  const right_ids = pluck(right, "id");
  const left_without_right = reject(left, (p) => right_ids.indexOf(p.id) != -1);
  return left_without_right.concat(right);
}
export function setPricesLoading(allPlans, excludePlanIds = []) {
  return allPlans.map((plan) =>
    excludePlanIds.includes(plan.id)
      ? plan
      : merge({}, plan, {
          prices_loading: true,
          average_monthly_premium_per_person: null,
          average_monthly_premium: null,
          employee_costs: [],
          total_cost: null,
        }),
  );
}
